import { isTesting } from '@embroider/macros';
import { waitForPromise } from '@ember/test-waiters';

// wrapper for set timeout
export const wait = async (t = 2000) =>
  waitForPromise(new Promise((r) => setTimeout(r, isTesting() ? 10 : t)));
